module.exports = __webpack_public_path__ + "static/media/Slide4.41e11b85.jpeg";